module.exports = __webpack_public_path__ + "static/media/m_eyeshape_downturned_darkbrown.5da00c12.png";